import UploadImageFormik from "components/UploadImageFormik";
import { Formik, Form } from "formik";
import renderElement from "helpers/renderElement";
import formatCurrency from "helpers/formatCurrency";
import { Button, Card, Modal } from "react-bootstrap";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { paymentGatOne, paymentUpdateOne } from "services/payment.service";

type Props = {};

export default function PaymentPage({}: Props) {
  const { paymentCode } = useParams();
  const { data, isLoading, refetch } = useQuery(
    ["payment-get-one", paymentCode],
    async () => {
      return await paymentGatOne({ _id: paymentCode as string });
    },
    {
      enabled: !!paymentCode, // Add this line to enable/disable the query based on businessId
    }
  );
  const onSubmit = async (value: any) => {
    try {
      console.log("value", value);
      const payload = Object.entries(value).map(([key, value]) => ({
        _id: key as string,
        value: value as string,
      }));
      await paymentUpdateOne({
        _id: paymentCode as string,
        payloadValue: payload,
      });
      refetch();
    } catch (e) {
      console.log("error", e);
    }
  };

  if (isLoading) return <p>loading...</p>;

  if (data?.status == "TRANSACTION_CHECKING") {
    return (
      <div className="container">
        <div className="flex md:justify-center items-center flex-col h-full min-h-screen py-4">
          <Card border="primary" className="w-full max-w-[900px]">
            <Card.Header className="bg-primary"></Card.Header>
            <Card.Body>
              <div className="text-lg font-bold mb-2">ກະລຸນາລໍຖ້າ</div>
              <div>ກຳລັງກວດສອບ...</div>
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }
  if (data?.status == "TRANSACTION_COMPLETED") {
    return (
      <div className="container">
        <div className="flex md:justify-center items-center flex-col h-full min-h-screen py-4">
          <Card border="primary" className="w-full max-w-[900px]">
            <Card.Header className="bg-primary"></Card.Header>
            <Card.Body>
              <div className="text-lg font-bold mb-2">ສຳເລັດ</div>
              <div>ການຊໍາລະເງິນແລ້ວ</div>
              <div className="text-green-600 text-2xl font-bold">
                {formatCurrency(data?.amount, data?.currency)}
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }
  if (
    data?.status == "TRANSACTION_FAILED" ||
    data?.status != "TRANSACTION_PENDING"
  ) {
    return (
      <div className="container">
        <div className="flex md:justify-center items-center flex-col h-full min-h-screen py-4">
          <Card border="primary" className="w-full max-w-[900px]">
            <Card.Header className="bg-primary"></Card.Header>
            <Card.Body>
              <div className="text-lg font-bold mb-2">ບໍ່ສຳເລັດ</div>
              <div>ການຊໍາລະເງິນບໍ່ສຳເລັດ</div>
              <div className="text-red-600 text-2xl font-bold">
                {formatCurrency(data?.amount, data?.currency)}
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <Formik initialValues={{}} onSubmit={onSubmit}>
        <Form>
          <div className="flex md:justify-center items-center flex-col h-full min-h-screen py-4">
            <Card border="primary" className="w-full max-w-[900px]">
              <Card.Header className="bg-primary"></Card.Header>
              <Card.Body>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-2 mb-5">
                  <div>
                    <div className="text-lg font-bold mb-2">ວິທີໃຊ້</div>
                    <div className="mb-2">
                      <div className="p-2 bg-neutral-100 rounded-lg">
                        <div>1.ໂອນຕາມຈຳນວນມາທີ່ບັນຊີນີ້</div>
                        <div className="text-[12px] text-neutral-600">
                          ຊື່ບັນຊີ: PHOUDTHAVISACK LSP
                        </div>
                        <div className="text-[12px] text-neutral-600">
                          ເລກບັນຊີ: 030-12-00-01549951-001
                        </div>
                        <div className="w-full max-w-[200px]">
                          <div className="p-2 bg-white rounded-lg overflow-hidden">
                            <img
                              src="/qr-code.jpeg"
                              alt="bcel"
                              className="w-full"
                            />
                          </div>
                        </div>
                        <div>2.ອັບໂຫລດສະລິບການໂອນເງິນ</div>
                        <div>3.ກົດ "ຍືນຍັນ"</div>
                        <div>4.ລໍຖ້າກວດສອບ</div>
                      </div>
                      {renderElement(data?.document)}
                    </div>

                    <div className="bg-white w-full max-w-600">
                      <Modal.Body>
                        <div className="flex flex-col gap-[10px] w-full mb-2">
                          {data?.payload?.map((e: any, i: any) => (
                            <UploadImageFormik
                              commentText={e?.title}
                              name={e?._id}
                              style={{ width: "100%", height: "200px" }}
                              rootStyle={{ width: "100%", display: "block" }}
                              key={i}
                            />
                          ))}
                        </div>
                      </Modal.Body>
                      {/* <Modal.Footer>
                        <Button
                          variant="primary"
                          type="submit"
                          className="w-full h-[54px] rounded-none"
                        >
                          ບັນທຶກ
                        </Button>
                      </Modal.Footer> */}
                    </div>
                  </div>
                  <div>
                    <div className="text-lg font-bold mb-2">Summary</div>
                    <div className="mb-2">
                      <div className="flex gap-2">
                        <div>
                          <img
                            src="/test-logo.jpg"
                            alt=""
                            className="w-[54px] h-[54px]"
                          />
                        </div>
                        <div>
                          <div className="font-bold">
                            {data?.businessId?.name}
                          </div>
                          <div
                            className="text-sm text-neutral-600 underline cursor-pointer"
                            hidden={!data?.businessId?.ref?.domain}
                          >
                            https://{data?.businessId?.ref?.domain}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="text-sm">
                        ລາຍລະອຽດ:{" "}
                        <span className="font-bold">TOP UP TO WEBSITE</span>
                      </div>
                    </div>
                    <hr />
                    <div>
                      {[
                        {
                          title: "ຈຳນວນເງິນ",
                          value: formatCurrency(data?.amount, data?.currency),
                        },
                        {
                          title: "ສວນຫຼຸດ",
                          value: formatCurrency(data?.discount, data?.currency),
                        },
                        {
                          title: "ຄ່າທຳນຽມ",
                          value: formatCurrency(
                            data?.feeAmount,
                            data?.currency
                          ),
                        },
                      ].map((e) => (
                        <div className="flex justify-between text-sm">
                          <div className="text-neutral-600">{e?.title}:</div>
                          <div className="text-neutral-950 font-bold">
                            {e?.value}
                          </div>
                        </div>
                      ))}
                    </div>
                    <hr />
                    <div className="flex justify-between text-green-600">
                      <div className="text-lg font-bold">
                        ເງິນທີຕ້ອງຊຳລະທັງໝົດ
                      </div>
                      <div className="text-xl font-bold">
                        {formatCurrency(data?.amount, data?.currency)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-2 md:flex justify-between px-2">
                  <Button
                    variant="outline-secondary"
                    type="button"
                    className="h-[54px] md:w-[200px]"
                  >
                    ຍົກເລີກ
                  </Button>
                  <Button
                    variant="primary"
                    type="submit"
                    className="h-[54px] md:w-[200px]"
                  >
                    ຍືນຍັນ
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </div>
        </Form>
      </Formik>
    </div>
  );
}
